import { UserAddress } from 'storage/user/user.model';
import { AddressDTO } from 'storage/client/client.model';
import { isRomanianAddressDTO } from 'components/AddressForm/ro/utils';

// TODO: Depracated, remove when remove old addresses endpoints
export const getAddressesWithoutNulls = (addresses: UserAddress[]) =>
  addresses.filter(
    ({
      addressId,
      addressType,
      street,
      buildingNumber,
      postalCode,
      city,
      countryCode,
      country
    }) =>
      ![
        addressId,
        addressType,
        street,
        buildingNumber,
        postalCode,
        city,
        countryCode,
        country
      ].includes(null)
  );

export const filterAddressesWithoutNulls = (addresses: AddressDTO[]) =>
  addresses.filter(
    ({
      id,
      type,
      street,
      buildingNumber,
      zipCode,
      city,
      countryCode,
      county,
      streetNumber
    }) => {
      const isRO = isRomanianAddressDTO({ county, streetNumber });
      return (
        isRO ||
        (!isRO &&
          ![
            id,
            type,
            street,
            buildingNumber,
            zipCode,
            city,
            countryCode
          ].includes(null))
      );
    }
  );
